import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { deDE } from '@mui/material/locale'

let theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#97D700',
      },
      secondary: {
        main: '#dc004e',
      },
      background: {
        default: '#f5f5f5',
        paper: '#ffffff',
      },
      po: {
        mintGreen: '#B2DFDB',
        pastelRed: '#FFCDD2',
        stripedGray: '#E0E0E0',
      },
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: 'none',
          },
        },
      },
    },
  },
  deDE
)

theme = responsiveFontSizes(theme)

export { theme }
